export default [
  {
    path: 'management',
    name: 'management',
    component: () => import('@/views/Management.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management',
      template: 'auth',
    },
  },
  {
    path: 'not-found',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      middleware: 'auth',
      template: 'auth',
    },
  },
  {
    path: '*',
    redirect: 'not-found',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      middleware: 'auth',
      template: 'auth',
    },
  },
];
